export const init = () => {


  // TRACKER 'DASHBOARD'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.customer.myDashboard);
  const classProductViewed = 'viewed';

  // ClickMenu
  /* => Moved to menu-tracker.js
	var clickMenu = new AnalyticsClickEvent('clickMenu', tracker.defaultEvent());
	clickMenu.domElement = '#dashboard-account-nav .account-navigation div.panel:nth-child(1)';
	clickMenu.options.label = 'ClickMenu';
	tracker.addEvent(clickMenu);
	*/

  // MyProfile
  const myProfile = new AnalyticsClickEvent('myProfile', tracker.defaultEvent());
  myProfile.domElement = 'div[data-tracking="card-my-profile"] .dash-card';
  myProfile.options.label = 'MyProfile';
  tracker.addEvent(myProfile);

  // MyOrders
  const myOrders = new AnalyticsClickEvent('myOrders', tracker.defaultEvent());
  myOrders.domElement = 'div[data-tracking="card-my-order"] .dash-card';
  myOrders.options.label = 'MyOrders';
  tracker.addEvent(myOrders);

  // Return
  const myReturn = new AnalyticsClickEvent('myReturn', tracker.defaultEvent());
  myReturn.domElement = 'div[data-tracking="card-my-returns"] .dash-card';
  myReturn.options.label = 'Return';
  tracker.addEvent(myReturn);

  // Store
  const myStore = new AnalyticsClickEvent('myStore', tracker.defaultEvent());
  myStore.domElement = 'div[data-tracking="card-my-store"] .dash-card';
  myStore.options.label = 'Store';
  tracker.addEvent(myStore);

  // Loyalty
  const myLoyalty = new AnalyticsClickEvent('myLoyalty', tracker.defaultEvent());
  myLoyalty.domElement = 'div[data-tracking="card-my-loyalty"] .dash-card';
  myLoyalty.options.label = 'Loyalty';
  tracker.addEvent(myLoyalty);

  // Opinion
  const myOpinion = new AnalyticsClickEvent('myOpinion', tracker.defaultEvent());
  myOpinion.domElement = 'div[data-tracking="card-my-opinion"] .dash-card';
  myOpinion.options.label = 'Opinion';
  tracker.addEvent(myOpinion);

  // My LVP History
  const myLVPHistory = new AnalyticsClickEvent('myLVPHistory', tracker.defaultEvent());
  myLVPHistory.domElement = 'div[data-tracking="card-my-last-viewed"] .dash-card-footer.clickable-area';
  myLVPHistory.options.label = 'MyLVPHistory';
  tracker.addEvent(myLVPHistory);

  const setProductLVPAsViewed = (indexLVP, $product) => {
    if (CUBE.Analytics.utils.isVisible($product) && !$product.hasClass(classProductViewed)) {
      const model = CUBE.Analytics.utils.perso.getLVPModel($product);
      CUBE.Analytics.enhanced.sendImpression(model);
      $product.addClass(classProductViewed);
    }
  };

  const sendImpressionLVP = (indexLVP) => {
    $('.slick-current .lvp-element').each(function(){
    		setProductLVPAsViewed(indexLVP, $(this));
    	});
  };


  // - DOTS LVP
  const eventDotsLVP = new AnalyticsSlickEvent('dotsLVP', new AnalyticsTracker(AnalyticsConstants.trackers.customer.lvp).defaultEvent());
  eventDotsLVP.domContainer = '.dash-card.last-products .slick-slider';
  eventDotsLVP.domElement = '.slide';
  eventDotsLVP.options.action = 'DashboardLvpDots';
  eventDotsLVP.trackDots();
  eventDotsLVP.postAction(($element) => {
    const indexLVP = $element.parent().find($element).index();
    if (indexLVP > 0) {
      sendImpressionLVP(indexLVP);
    }
  });


  tracker.addEvent(eventDotsLVP);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};



// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/dashboard-tracker.js